import React from 'react';
import GIELink from "../GIELink/GIELink";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

export default class TitleListScreen extends React.Component<any, any> {
  render() {
    const {href, miniTitle, title, thirdHref} = this.props;
    return (
      <div className="container-xl title-wrapper px-xl-0 px-5 gie-services-container">
        <div className="gie-breadcrumb">
          <GIELink href="accueil">Accueil</GIELink>
          <KeyboardArrowRightIcon/>
          <GIELink href={href} className={thirdHref ? "" : "active-link"}>{miniTitle}</GIELink>
          {thirdHref && <>
              <KeyboardArrowRightIcon/>
              <GIELink href={thirdHref} className="active-link">{title}</GIELink>
          </>}
        </div>
        <div className="fs-3 text-uppercase service-title">{miniTitle}</div>
        <div className="fs-1 service-description">{title}</div>
      </div>
    );
  }
}
